import React, {Component} from 'react';
import './vip.less';

//商品类型模版
class Vip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: [],
      level: ['铜牌', '银牌', '金牌', '白金', '钻石', '联'],
    };
  }

  componentWillMount() {
    this.setState({status: Number(this.props.status)});
  }

  componentWillReceiveProps(props) {
    this.setState({status: Number(props.status)});
  }

  render() {
    const {status, level} = this.state;
    return (
      <div id="vip">
        <div className={`tag tag-${status}`}><i className={`icon-s${status}`}><s>.</s></i>{level[status]}</div>
      </div>
    );
  }
}
export default Vip;



// WEBPACK FOOTER //
// ./src/components/frontEnd/vip/vip.jsx